const state = {
  // enabled: false,
  mainInstances: [
    {
      title: 'Управление аккаунтом',
      router: 'Main',
    },
    {
      title: 'Обновления',
      router: 'Info',
    },
  ],
  secondInstances: [
    {
      name: 'allServices',
      title: 'Все сервисы',
      enabled: false,
      router: '/tools',
    },
    {
      name: 'muctr',
      title: 'Офицальный сайт',
      enabled: false,
      url:'https://muctr.ru/'
    },
    {
      name: 'mail',
      title: 'Корпоративная почта',
      enabled: false,
      url:'https://mail.muctr.ru/'
    },
    {
      name: 'paymuctr',
      title: 'Оплата услуг университета',
      enabled: false,
      url:'https://pay.muctr.ru/'
    },
    {
      name: 'queue',
      title: 'Очередь на мат. помощь',
      enabled: false,
      url:'https://queue.muctr.ru/'
    },
    {
      name: 'concil',
      title: 'Диссертации',
      enabled: false,
      url:'https://diss.muctr.ru/'
    },
    {
      name: 'diss',
      title: 'Дисс. советы',
      enabled: false,
      url:'https://council.muctr.ru/'
    },
    {
      name: 'PlaceBreadcrumbs',
      title: 'Бронирование помещений ВКС',
      url:'https://portal.muctr.ru/reserver/',
      enabled: false,
    },
  ],
  userActions: [
    {
      title: 'Профиль',
      url: 'https://portal.muctr.ru/',
    },
  ],
  title: 'Система учета деятельности диссертационных советов',
  userAvatar: null,
};

const mutations = {
  changeTitle(state, title) {
    state.title = title
  },
  changeAvatar(state, Avatar) {
    state.userAvatar = Avatar
  },
};

export default {
  namespaced: true,
  state,
  mutations,
}
